import Supervisor from '../../../src/components/electeds/supervisors';

export const Engardio = new Supervisor({
  firstName: 'Joel',
  lastName: 'Engardio',
  phone: '(415) 554-7460',
  growSfEndorsed: false,
  specialElection: null,
  elected: '11/8/2022',
  margin: 469,
  reElected: null,
  appointed: null,
  nextElection: null,
  leftOffice: '10/18/2025',
  type: 'Supervisor',
  district: '4',
  archive: true,
});

export default Engardio;
